import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, NgForm } from '@angular/forms';
import { AuthService } from '../../shared/services/auth/auth.service';
import { Router, ActivatedRoute, Params, RouterLink } from '@angular/router';
import { ToastService } from '../../shared/services/toast.service';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import { StaticValueService } from '../../shared/services/static-value.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatButton, MatDialogActions, MatDialogClose, MatStepper} from '@angular/material';


@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit {
    form: FormGroup;
    public formSubmitAttempt: boolean;
    public user_id: string;
    public password;
    public username;
    public confirmPassword;
    public passwordMatchBool: Boolean = false;
    public errorMessage: any;
    public showPasswordInfo = false;
    public linkedinId;
    public lineId;
    public language = 'english';

    constructor(public fb: FormBuilder,
        public route: ActivatedRoute,
        public authService: AuthService,
        public toastService: ToastService,
        public dialog: MatDialog,
        public translateService: TranslateService,
        public staticService: StaticValueService,
        public router: Router) { }

    ngOnInit() {
        this.form = this.fb.group({    // {5}
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
        this.linkedinId = this.route.snapshot.queryParamMap.get('linkedinId');
        this.lineId = this.route.snapshot.queryParamMap.get('lineId');
        this.route.params.subscribe(params => {
            this.user_id = params['id'];
            this.authService.getUser(this.user_id).subscribe(data => {
                let user = data[0];
                console.log(user.hash_password)
                if (user.hash_password === undefined) { } else {
                    this.router.navigate(['../login']);
                }
            }, error => {
                console.log('Error while getting user', error);
            })
        });
    }

    isFieldInvalid(field: string) { // {6}
        return (
            (!this.form.get(field).valid && this.form.get(field).touched) ||
            (this.form.get(field).untouched && this.formSubmitAttempt)
        );
    }

    onSubmit() {
        let user = {};
        if (this.password === this.confirmPassword) {

        }
        user['username'] = this.username;
        user['password'] = this.password;
        user['userId'] = this.user_id;
        if (this.linkedinId) {
            user['linkedinLogin.id'] = this.linkedinId;
        }
        if (this.lineId) {
            user['lineLogin.id'] = this.lineId;
        }

        this.authService.signup(user).subscribe(data => {
            const dialogRef = this.dialog.open(SignupConfirmDialogComponent, {
                // width: '400px',
                data: 'plan'
              });
              dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.router.navigate(['../login']);
                    // this.toastService.success();
                }
              });
        }, error => {
            if (error.error.code === 11000) {
                this.errorMessage = `username '${this.username}' already exist`
            }
            this.toastService.error('Sign-up unsuccessful');
        })
        this.formSubmitAttempt = true;             // {8}
    }

    passwordMatch() {
        if (this.password === this.confirmPassword) {
            this.passwordMatchBool = false;
        } else {
            this.passwordMatchBool = true;
        }
    }

    linkedinSignup() {
        this.authService.linkedinSignUp(this.user_id, false).subscribe(res => {
            window.location.href = res['linkedinUrl'];
        }, err => { });
    }

    lineSignup() {
        this.authService.lineSignUp(this.user_id, false).subscribe(res => {
            console.log(res);
            window.location.href = res['lineUrl'];
        }, err => { });
    }

    languageChange(lang: string) {
        this.translateService.use(lang);
        this.language=lang;
        this.staticService.setLanguage(lang);
    }

}


// <mat-dialog-actions style="display: block;">
// <button class="btn btn-space btn-default" mat-dialog-close>Cancel</button>
// <button class="btn btn-space btn-primary" (click)="proceed('search')" [mat-dialog-close]="true">Proceed</button>

// </mat-dialog-actions>

@Component({
    selector: 'signup-confirm-dialog',
    template: `
    <div class="text-center">
    <div><span class="mdi mdi-check-circle font-60 blue-text" style="color: #4285f4;"></span></div>
    <h3 translate="" ng-reflect-translate="">Success</h3>
    <mat-dialog-content>Your signup has been successfully completed!</mat-dialog-content>
    <br>
    <mat-dialog-content (click)="proceed('search')" style="cursor:pointer;"><a>Proceed to login page</a></mat-dialog-content>

  </div>
    `
  })
  export class SignupConfirmDialogComponent {
    constructor(
      public dialogRef: MatDialogRef<SignupConfirmDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) {
      }
    onNoClick(): void {
      this.dialogRef.close();
    }
    proceed(redirect){
      this.dialogRef.close(redirect);
    }
  }